import { ColumnDef } from "@tanstack/react-table";
import { INTERNAL_TRANSACTION_TYPE_TO_LABEL } from "@/internal-transactions/constants";
import { IInternalTransaction } from "@/internal-transactions/InternalTransactions";

export const TypeCol = (): ColumnDef<IInternalTransaction> => ({
  header: "Type",
  accessorKey: "type",
  cell: ({ row }) => {
    const { type } = row.original;
    return INTERNAL_TRANSACTION_TYPE_TO_LABEL[type];
  },
});
